<template>
  <AutomationCard
      v-if="isAutomation"
      :automation="model"
      @click="open"
  />
  <GlobalAutomationCard
      v-else-if="isGlobalAutomationConfiguration"
      :automation="model"
      :automation-configuration="model"
      @click="open"
  />
  <UnconfiguredGlobalAutomation
      v-else-if="isGlobalAutomation"
      :global-automation="model"
      @click="open"
  />
</template>

<script>
import AutomationCard from './AutomationCard.vue'
import GlobalAutomationCard from './GlobalAutomationCard.vue'
import UnconfiguredGlobalAutomation from './UnconfiguredGlobalAutomation.vue'
import AutomationableTypeEnum from '~/pages/automation/enums/AutomationableTypeEnum'

export default {
  name: 'Automationable.vue',
  components: {
    GlobalAutomationCard,
    AutomationCard,
    UnconfiguredGlobalAutomation
  },
  props: {
    automationable: {
      model_type: Object,
      id: Number,
      model: Object,
      default: null,
    },
  },
  computed: {
    model () {
      return this.automationable?.model?.data
    },
    isGlobalAutomation () {
      return this.automationable?.model_type === AutomationableTypeEnum.GLOBAL_AUTOMATION
    },
    isAutomation () {
      return this.automationable?.model_type === AutomationableTypeEnum.AUTOMATION
    },
    isGlobalAutomationConfiguration () {
      return this.automationable?.model_type === AutomationableTypeEnum.GLOBAL_AUTOMATION_CONFIGURATION
    },
  },
  methods: {
    open () {
      if (this.isAutomation) {
        this.navigator.navigatePath(
          this.route('vue.dashboard.automations.show', { automation: this.model?.id })
        )
      } else if (this.isGlobalAutomationConfiguration) {
        this.navigator.navigatePath(
          this.route('vue.dashboard.automations.global.show', { automation: this.model?.global_automation?.data?.id })
        )
      } else if (this.isGlobalAutomation) {
        this.navigator.navigatePath(
          this.route('vue.dashboard.automations.global.edit', { automation: this.model?.id })
        )
      }
    },
  }
}
</script>

<style scoped>

</style>
